import FullPageLayout from './FullPageLayout';

export default FullPageLayout;
